// extracted by mini-css-extract-plugin
export default {"wrapper":"Rn-z","response":"Sn-z","error":"Tn-z","disabled":"Un-z","buttons":"Vn-z","feedbackQuestionSection":"Wn-z","yesNoWrapper":"Xn-z"};